import {loginContainer} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';

import AutoLayoutBox from './AutoLayoutBox';
import {getCurrentScreenId, getStateMetadata} from '../auto_layout_selectors';

// eslint-disable-next-line react/prefer-stateless-function
class AutoLayoutContainer extends React.Component {
  render() {
    const {
      autoLayoutStateId,
      config,
      configStateId,
      currentContextParams,
      currentScreenId,
      isLoadingCounter,
      loadingDisabled,
      metadata,
      screenStyles,
      showBoxHeader,
      titleText,
      helpText,
    } = this.props;
    return (
      <AutoLayoutBox
        autoLayoutStateId={autoLayoutStateId}
        config={config}
        configStateId={configStateId}
        contextParams={currentContextParams}
        isLoadingCounter={isLoadingCounter}
        loadingDisabled={loadingDisabled}
        metadata={metadata}
        screenId={currentScreenId}
        screenStyles={screenStyles}
        showBoxHeader={showBoxHeader}
        titleText={titleText}
        helpText={helpText}
      />
    );
  }
}

AutoLayoutContainer.displayName = 'AutoLayoutContainer';

AutoLayoutContainer.propTypes = {
  autoLayoutStateId: PropTypes.string.isRequired,
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  configStateId: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  loadingDisabled: PropTypes.bool,
  screenStyles: PropTypes.objectOf(PropTypes.any),
  showBoxHeader: PropTypes.bool,
  titleText: PropTypes.string,
};

AutoLayoutContainer.defaultProps = {
  helpText: '',
  loadingDisabled: false,
  screenStyles: undefined,
  showBoxHeader: false,
  titleText: '',
};

export default connect((state, props) => ({
  currentContextParams: state[props.autoLayoutStateId].currentContextParams,
  isLoadingCounter: state[props.autoLayoutStateId].isLoadingCounter,
  currentScreenId: getCurrentScreenId(state, props),
  metadata: getStateMetadata(state, props),
}))(AutoLayoutContainer);
